export default __webpack_public_path__ + "static/media/rental-equipment1.d0930e84.jpg";